import React from 'react';
import PropTypes from 'prop-types';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

const InformationStack = ({
  text,
  backgroundColor,
  textColor,
  variant,
  fontWeight,
  IconComponent,
  iconLast,
  sx,
  isClickable,
  ...props
}) => (
  <Stack
    direction={iconLast ? 'row-reverse' : 'row'}
    alignItems="center"
    spacing={1}
    sx={{
      width: 'fit-content',
      backgroundColor,
      cursor: isClickable ? 'pointer' : 'default',
      ...sx,
    }}
    {...props}
  >
    {IconComponent && IconComponent}
    <Typography
      variant={variant}
      color={textColor}
      sx={{ fontWeight, textAlign: 'center' }}
    >
      {text}
    </Typography>
  </Stack>
);

InformationStack.propTypes = {
  text: PropTypes.string.isRequired,
  backgroundColor: PropTypes.string,
  textColor: PropTypes.string,
  variant: PropTypes.string,
  fontWeight: PropTypes.number,
  IconComponent: PropTypes.element,
  iconLast: PropTypes.bool,
  sx: PropTypes.shape({}),
  isClickable: PropTypes.bool,
};

InformationStack.defaultProps = {
  backgroundColor: 'primary.A100',
  textColor: 'text.primary',
  variant: 'medium_1',
  fontWeight: 500,
  IconComponent: undefined,
  iconLast: false,
  sx: {},
  isClickable: false,
};

export default InformationStack;
